import React, { useState, useEffect } from "react";
import "./AdminSetPassword.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import userApi from "../../../services/apiServices/userApi"; // Adjust the path to match your structure
import { setLoading } from "../../../services/redux/loadingSlice";
import { useDispatch } from "react-redux";
import MessageModal from "../../../components/common/Modals/MessageModal/MessageModal";
import PageTitle from "../../../components/common/PageTitle/PageTitle";

const AdminSetPassword = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [isMessageOpen, setIsMessageOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    useEffect(() => {
        if (!token) {
            setMessage("Token inválido. Verifique o link enviado por e-mail.");
            setIsMessageOpen(true);
        }
    }, [token]);

    const openMessageModal = () => {
        setIsMessageOpen(true);
    };

    const closeMessageModal = () => {
        setIsMessageOpen(false);
        if (message.includes("sucesso")) {
            navigate("/admin/login");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!password || !confirmPassword) {
            setError("Preencha todos os campos.");
            return;
        }
        if (password !== confirmPassword) {
            setError("As senhas não coincidem.");
            return;
        }

        try {
            dispatch(setLoading(true));
            const response = await userApi.setPassword(token, { password });

            setMessage(response.message || "Senha definida com sucesso!");
            openMessageModal();
        } catch (error) {
            console.error("Error setting password:", error);
            setError("Erro ao definir senha. Verifique o link ou tente novamente.");
        } finally {
            dispatch(setLoading(false));
        }
    };

    return (
        <div className="page">
            <MessageModal
                isOpen={isMessageOpen}
                click={closeMessageModal}
                message={message}
            />
            <PageTitle title="Definição de Senha" />
            <p>
                Crie uma nova senha para sua conta administrativa.
            </p>
            <form className="form-password" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="password" className="login-label">
                        Nova senha
                    </label>
                    <input
                        type="password"
                        id="password"
                        className="main-input"
                        placeholder="Digite a nova senha"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="confirmPassword" className="login-label">
                        Confirmar senha
                    </label>
                    <input
                        type="password"
                        id="confirmPassword"
                        className="main-input"
                        placeholder="Confirme a nova senha"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button type="submit" className="main-button">
                    Salvar Senha
                </button>
            </form>
        </div>
    );
};

export default AdminSetPassword;
